import { useRef, useCallback } from 'react';
import { trackEvent } from '../services/monitoring';

const sent = new Set();

export function clearPageLoadCache() {
  sent.clear();
}

export default function usePageLoad(pageName) {
  const t0 = useRef(performance.now());

  const markLoaded = useCallback((extra = {}) => {
    if (sent.has(pageName)) return;
    sent.add(pageName);
    trackEvent('page_loaded', {
      page: pageName,
      load_time_ms: Math.round(performance.now() - t0.current),
      ...extra,
    });
  }, [pageName]);

  return markLoaded;
}
